import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ArrowRightOrange from '../../assets/images/common/arrow-right-orange.svg';

import { SCREEN_NAME, TEMP_TYPE } from '../../types/common/CommonType';

import { EditDeviceListRow } from './EditDeviceListRow';
import { SearchTextField } from '../../components/SearchTextField';
import { TempSaveButton } from '../../components/TempSaveButton';
import { ErrorModalModal } from '../../components/ErrorModal';
import { CoverProgressLoading } from '../../components/CoverProgressLoading';
import { addRow as setMoveScreen } from '../../slice/ScreenHistorySlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { estimateApi } from '../../api/estimate';


export const EditDeviceList = () => {
    const navigation = useNavigate();
    const dispatch = useAppDispatch();
    const { draftInquiryEstimateId } = useParams();

    // 見積り問合せ
    const estimateInquiry = useAppSelector((s) => s.EstimateInquiry);
    // client-id取得
    const clientId = useAppSelector((s) => s.ClientId);
    // API実行状況管理
    const [loadingStatus, setLoadingStatus] = useState<boolean>(false);
    // 都道府県、市区町村のマスタ
    const masterPrefecture = useAppSelector((s) => s.MasterPrefecture);

    // エラーモーダル制御
    const [errerModal, setErrorModal] = useState<boolean>(false);
    const [errorModalMessage, setErrorModalMessage] = useState<Array<string>>([]);

    const moveEditEstimate = () => {
        navigation('/editEstimate');
    };

    // 画面遷移ルート追加
    useEffect(() => {
        dispatch(setMoveScreen(SCREEN_NAME.EDIT_DEVICE_LIST));
        // 一時保存からの復帰制御
        if (draftInquiryEstimateId) {
            const draftDataSet = async () => {
                const getDarftRet = await estimateApi.getDraftEstimate(draftInquiryEstimateId, dispatch);
                if (getDarftRet !== '') {
                    setErrorModalMessage([getDarftRet]);
                    setErrorModal(true);
                }
            };
            void draftDataSet();
        }
    }, []);

    // ローディングステータス管理
    useEffect(() => {
        // マスタが取得できていればローディングステータス更新
        if (masterPrefecture.prefecture.length > 0) {
            setLoadingStatus(true);
        }
    }, [masterPrefecture]);

    return (
        <>
        {loadingStatus ? (
        <>
            <section className='section page_title'>
                <div className='container'>
                    <div className='columns is-desktop'>
                        <div className='column is-2-desktop is-12-mobile page_title-thead'>
                            <h1>見積り機器編集</h1>
                        </div>
                        <div className='column is-10-desktop is-12-mobile page_title-search_box--wrapper'>
                            <p className='discription'>
                                保有機器を追加したい方は
                                <br className='is-hidden-mobile' />
                                こちらから再入力・再検索を行ってください。
                            </p>
                            <SearchTextField inputClassName={'input is-top_search'} buttonClassName={'button'} />
                        </div>
                    </div>
                </div>
            </section>
            <div className='device-list-area'>
                <h2>見積り機器</h2>
                <p className='device-list-description'>
                    お客様にてお見積りをする機器の設置場所と数量の選択入力をお願い致します。
                    <br />
                    <strong>『設置情報を追加する』</strong>
                    ボタンで機器の設置場所と台数の編集行の追加ができます。
                </p>
                {(estimateInquiry.deviceList ?? []).map((deviceRow, index) => {
                    return (
                        <React.Fragment key={`device-list-row-${index}`}>
                            <EditDeviceListRow
                                rowNumber={deviceRow.deviceRowNumber}
                                estimateInquiry={estimateInquiry}
                                deviceInfoRow={deviceRow}
                                dispatch={dispatch}
                                masterPrefecture={masterPrefecture}
                            />
                        </React.Fragment>
                    );
                })}
            </div>
            <div className='bottom_cta--next'>
                <TempSaveButton
                    clientId={clientId}
                    estimateInquiry={estimateInquiry}
                    tempSaveType={TEMP_TYPE.DEVICE_TEMP}
                />
                <a className='button is-dl_blue' onClick={moveEditEstimate}>
                    見積り条件の編集
                    <span className='icon is-small'>
                        <img src={ArrowRightOrange} alt='' />
                    </span>
                </a>
            </div>
            <ErrorModalModal errorMessages={errorModalMessage} openState={errerModal} setOpenState={setErrorModal} />
        </>
        ) : (<CoverProgressLoading />)} 
        </>
    );
};
